export const UPDATE_PAGE_PROGRESS = 'UPDATE_PAGE_PROGRESS';
